import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { EmailDialogType } from "src/app/constants/email-dialog-type";
import { TableColumnType } from "src/app/constants/table";
import { ApiStatus } from "src/app/models/api";
import { BenefitSummaryEmailCriteria, BenefitSummaryItem, BenefitSummaryItemList } from "src/app/models/benefit-summary";
import { EmailDocumentDialogModel } from "src/app/models/dialog";
import { TableColumn } from "src/app/models/table";
import { BenefitService } from "src/app/services/benefit.service";
import { HelperService } from "src/app/services/helper.service";
import { DialogEmailDocumentComponent } from "../../shared/dialog/email-document.component";


@Component({
    selector: "mwp-benefit-summaries",
    templateUrl: "./benefit-summaries.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentBenefitSummariesComponent implements OnInit {
    public apiUrl = ContentHeaderKey.EnrollmentBenefitSummary;
    public benefitSummaryList: BenefitSummaryItem[];
    public apiStatus = new ApiStatus();

    public benefitSummariesMatTableData: MatTableDataSource<BenefitSummaryItem>;
    public benefitSummariesColumns: TableColumn[] = [
        {
            columnName: 'File Name',
            propertyId: 'linkText',
            columnType: TableColumnType.label,
            width: '25%'

        },
        {
            columnName: 'Checkout Completed On',
            propertyId: 'createdOn',
            columnType: TableColumnType.label,
            width: '28%'
        },
        {
            columnName: 'Actions',
            propertyId: 'fileType',
            columnType: TableColumnType.button,
            dataTypeText: "Download",
            width: '11%',

        },
        {
            columnName: '',
            propertyId: 'benefitSummaryID',
            columnType: TableColumnType.button,
            dataTypeText: "Email",
            isButtonSelection2: true,
            width: '11%',

        },

    ];
    constructor(
        private benefitService: BenefitService,
        private helperService: HelperService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.benefitService.getBenefitSummaries().subscribe((response: BenefitSummaryItemList) => {
            this.benefitSummariesMatTableData = new MatTableDataSource<BenefitSummaryItem>();
            this.benefitSummariesMatTableData.data = response.benefitSummaryItems;
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }

    public downloadBenefitSummary(benefitSummaryItem: BenefitSummaryItem): void {
        this.benefitService.getBenefitSummary(benefitSummaryItem.benefitSummaryID).subscribe((response: Blob) => {
            let l_BinaryData = [];
            l_BinaryData.push(response);
            this.helperService.downloadDocument(l_BinaryData, response.type, `${benefitSummaryItem.fileName}${benefitSummaryItem.fileType}`);
        }
        );
    }

    public openEmailDialog(benefitSummaryItem: BenefitSummaryItem): void {
        const dialogRef = this.dialog.open(DialogEmailDocumentComponent, {
            data: EmailDialogType.benefitSummary,
            panelClass: 'mwp-modal-override-800'
        });

        dialogRef.afterClosed().subscribe((response: EmailDocumentDialogModel) => {
            if (response != null) {
                const l_BenefitSummaryEmailCriteria: BenefitSummaryEmailCriteria = new BenefitSummaryEmailCriteria();
                l_BenefitSummaryEmailCriteria.toAddress = response.email;
                l_BenefitSummaryEmailCriteria.benefitSummaryID = benefitSummaryItem.benefitSummaryID;
                this.benefitService.sendBenefitSummaryToEmail(l_BenefitSummaryEmailCriteria).subscribe(() => {
                });
            }
        });
    }
}
